import React, { useEffect, useState } from "react";
import { Calendar } from "antd";
import "./Days.css";
import locale from 'antd/es/locale/pt_PT';
const Days = ({ setSelectedDay, setDay }) => {


  const handleDaySelect = (value) => {
    const date = new Date(value.$d);
    const options = { weekday: "short" };
    const dayName = date.toLocaleDateString("pt-PT", options);
    setSelectedDay(dayName);
    switch (dayName) {
      case "segunda":
        setDay(1);
        break;
      case "terça":
        setDay(2);
        break;
      case "quarta":
        setDay(3);
        break;
      case "quinta":
        setDay(4);
        break;
      case "sexta":
        setDay(5);
        break;
      case "sábado":
        setDay(6);
        break;
      case "domingo":
        setDay(7);
        break;

      default:
        break;
    }
  };


  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Calendar
        onSelect={handleDaySelect}
        fullscreen={false}
        locale={locale}
      />
    </div>
  );
};

export default Days;
